module.exports = __webpack_public_path__ + "static/projekt_indywidualny_c04-f459c98bfda66b3ffa1505dbea052ee2.jpg";